import { DateObject } from "react-multi-date-picker";
import { UpdatePeakSurcharge } from "../dtos/UpdateRateCardRequest";
import {
  UpdatePeakSurchargeUIRequest,
  UpdateRouteRateUIRequest,
} from "../routeRate/UpdateRouteRateModal";

export const mapValuesUiRequestToUpdatePeakSurcharge = (
  uiRequest: UpdateRouteRateUIRequest
): UpdatePeakSurcharge[] => {
  let peakSurchargeList: UpdatePeakSurcharge[] = [];

  // Check if peak surcharge should be processed
  if (uiRequest.show_peak_surcharge && uiRequest.peakSurcharge.length > 0) {
    uiRequest.peakSurcharge.forEach((surcharge) => {
      if (
        surcharge.peakSurchargeType &&
        (surcharge.peak_surcharge_value_percentage ||
          surcharge.peak_surcharge_value_dollar)
      ) {
       // Extract the date range (always guaranteed to have two values)
        const [startDate, endDate] = surcharge.peak_surcharge_date_range;

       // Ensure the dates are converted to the required format
        const minDate = startDate && startDate.toDate() ? formatDateTime(startDate.toDate()) : null;
        const maxDate = endDate && endDate.toDate() ? formatDateTime(endDate.toDate()) : null;
     

        let peakSurchargeItem: UpdatePeakSurcharge = {
          peakSurchargeId: surcharge.peakSurchargeId ?? undefined,
          isActive: true,
          peakSurchargeMinDate: minDate,
          peakSurchargeMaxDate: maxDate,
          peakSurchargeType: surcharge.peakSurchargeType,
          peakSurchargeValue:
            (surcharge.peakSurchargeType === "percentage"
              ? surcharge.peak_surcharge_value_percentage
              : surcharge.peak_surcharge_value_dollar) ?? 0,
        };

        // Add the item to the list
        peakSurchargeList.push(peakSurchargeItem);
      }
    });
  }

  return peakSurchargeList;
};



export const formatDateTime = (date: Date | null | undefined): string | null => {
  if (!date) return null;

  const year = date.getFullYear().toString().padStart(4, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");

  return `${year}-${month}-${day}`; // Just the date
};

export const mapUpdatePeakSurchargeToUiRequest = (
  peakSurchargeList: UpdatePeakSurcharge[] | undefined
): UpdatePeakSurchargeUIRequest[] => {
  let uiRequestList: UpdatePeakSurchargeUIRequest[] = [];

  if (peakSurchargeList && peakSurchargeList.length > 0) {
    peakSurchargeList.forEach((surcharge) => {
      const minDate = surcharge.peakSurchargeMinDate
        ? new DateObject(surcharge.peakSurchargeMinDate) // Convert to DateObject
        : null;

      const maxDate = surcharge.peakSurchargeMaxDate
        ? new DateObject(surcharge.peakSurchargeMaxDate) // Convert to DateObject
        : null;

      let uiItem: UpdatePeakSurchargeUIRequest = {
        peakSurchargeId: surcharge.peakSurchargeId ?? undefined,
        peak_surcharge_date_range: minDate && maxDate ? [minDate, maxDate] : [],
        peakSurchargeType: surcharge.peakSurchargeType,
        peak_surcharge_value_percentage:
          surcharge.peakSurchargeType === "percentage"
            ? surcharge.peakSurchargeValue
            : undefined,
        peak_surcharge_value_dollar:
          surcharge.peakSurchargeType === "value"
            ? surcharge.peakSurchargeValue
            : undefined,
      };

      uiRequestList.push(uiItem);
    });
  }

  return uiRequestList;
};



// formats Date Object to string in "YYYY-MM-DD HH:mm:ss" format
// export const formatDateTime = (date: Date): string => {
//   const year = date.getFullYear().toString().padStart(4, "0");
//   const month = (date.getMonth() + 1).toString().padStart(2, "0");
//   const day = date.getDate().toString().padStart(2, "0");
//   const hours = date.getHours().toString().padStart(2, "0");
//   const minutes = date.getMinutes().toString().padStart(2, "0");
//   const seconds = date.getSeconds().toString().padStart(2, "0");

//   // return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
//   return `${year}-${month}-${day}T00:00:00.000+00:00`;
// };

// // formats string to Date Object in "YYYY-MM-DD HH:mm:ss" format
// export const convertStringToDateTime = (date: string): Date => {
//   // currently we date in 2024-12-24T00:00:00.000+00:00 format so we need to convert it to YYYY-MM-DD HH:mm:ss
//   date = `${date.split("T")[0]} 00:00:00`;
//   let arr = date.split(/-|\s|:/); // split string and create array.
//   return new Date(
//     Number(arr[0]),
//     Number(arr[1]) - 1,
//     Number(arr[2]),
//     Number(arr[3]),
//     Number(arr[4]),
//     Number(arr[5])
//   ); // decrease month value by 1
// };
